<div
  [ngClass]="{ 'standalone-mode modal-content': isStandaloneMode }"
  class="organization-modal"
  [attr.piqetAngularDraggable]="!isStandaloneMode ? '' : null"
>
  <div class="modal-header" *ngIf="!isStandaloneMode">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">
        {{ modalLabel }}
      </div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body">
    <div class="bootstrap-dialog-body">
      <div>
        <form [formGroup]="manageUserForm" [ngClass]="{ 'disabled-popup': !checkEntireAccess }">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group required">
                <piqet-angular-common-input
                  formControlName="firstName"
                  [control]="manageUserForm.get('firstName')"
                  label="First name"
                  placeholder="First name"
                  [maxLength]="50"
                  [submitted]="submitted"
                  [inputType]="'text'"
                  [errorMessages]="{
                    required: 'The first name field is required.',
                    minlength: 'The firstname must be at least 2 characters long.'
                  }"
                >
                </piqet-angular-common-input>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group required">
                <piqet-angular-common-input
                  formControlName="lastName"
                  [control]="manageUserForm.get('lastName')"
                  label="Last name"
                  placeholder="Last name"
                  [maxLength]="50"
                  [submitted]="submitted"
                  [inputType]="'text'"
                  [errorMessages]="{
                    required: 'The last name field is required.',
                    minlength: 'The lastname must be at least 2 characters long.'
                  }"
                >
                </piqet-angular-common-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div
              [ngClass]="shouldShowOrganizationField() ? 'col-sm-6' : 'd-none'"
              *ngIf="shouldShowOrganizationField()"
            >
              <div class="form-group">
                <label
                  *ngIf="manageUserForm.get('organizationName')?.value"
                  class="sub-header-drpdown"
                  >Organization *</label
                >
                <ng-container *ngIf="!isFromAdminOrg">
                  <ng-select
                    [clearable]="true"
                    [clearOnBackspace]="false"
                    #organization
                    [items]="organizationlist"
                    formControlName="organizationName"
                    [searchable]="false"
                    bindLabel="name"
                    bindValue="id"
                    [readonly]="isReadOnly"
                    placeholder="Organization name *"
                    (change)="getAllRolesList($event)"
                  >
                    <ng-template ng-header-tmp>
                      <div class="has-feedback">
                        <input
                          type="text"
                          class="form-control accordion-search search-input"
                          id="inputValidation"
                          placeholder="Search..."
                          (input)="organization.filter($any($event.target).value)"
                        />
                        <span class="form-control-feedback">
                          <i class="fa fa-search icon"></i>
                        </span>
                      </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                      <div title="{{ item?.name }}">
                        <span [ngOptionHighlight]="search">{{ item.name }}</span>
                        <span *ngIf="item.selected" class="badge badge-danger">Inactive</span>
                      </div>
                    </ng-template>
                  </ng-select>
                  <div
                    *ngIf="submitted && manageUserForm.controls['organizationName']?.invalid"
                    class="input-error"
                  >
                    Organization name is required.
                  </div>
                </ng-container>

                <!-- FOR ADMIN ORG MEMBERSHIP -> ADD USER -->
                <ng-select
                  *ngIf="isFromAdminOrg"
                  [clearable]="true"
                  [clearOnBackspace]="false"
                  #adminOrganization
                  [items]="organizationlist"
                  formControlName="organizationName"
                  [searchable]="false"
                  [(ngModel)]="orgName"
                  [readonly]="isReadOnly"
                  placeholder="Organization name"
                  (change)="getAllRolesList($event)"
                >
                  <ng-template ng-header-tmp>
                    <div class="has-feedback">
                      <input
                        type="text"
                        class="form-control accordion-search search-input"
                        id="inputValidation"
                        placeholder="Search..."
                        (input)="adminOrganization.filter($any($event.target).value)"
                      />
                      <span class="form-control-feedback">
                        <i class="fa fa-search icon"></i>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div [ngClass]="shouldShowOrganizationField() ? 'col-sm-6' : 'col-sm-12'">
              <div class="form-group required">
                <piqet-angular-common-input
                  formControlName="email"
                  [control]="manageUserForm.get('email')"
                  label="Email"
                  placeholder="Email"
                  [maxLength]="150"
                  [submitted]="submitted"
                  [inputType]="'email'"
                  (customBlur)="getEmailValidation()"
                  (inputEvent)="changeEmail($event)"
                  [errorMessages]="{
                    required: 'The email field is required.',
                    email: 'Invalid email address'
                  }"
                >
                </piqet-angular-common-input>

                <div
                  *ngIf="
                    isEmailValid &&
                    !!currentEmail &&
                    manageUserForm.get('email')?.valid &&
                    manageUserForm.get('email')?.value &&
                    manageUserForm.get('email')?.value === currentEmail &&
                    customData.userName !== manageUserForm.controls['email'].value
                  "
                  class="input-error"
                >
                  {{ currentEmail }} is already taken.
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6" *ngIf="shouldShowRoleField()">
              <div class="form-group">
                <label
                  *ngIf="manageUserForm.get('accessRole')?.value"
                  class="sub-header-drpdown pb-2"
                  >Role *</label
                >
                <ng-select
                  [clearable]="true"
                  [clearOnBackspace]="false"
                  #role
                  [items]="roleAccesslist"
                  [searchable]="false"
                  bindLabel="name"
                  [searchFn]="commonInputSearch"
                  formControlName="accessRole"
                  placeholder="Role *"
                >
                  <ng-template ng-header-tmp>
                    <div class="has-feedback">
                      <input
                        type="text"
                        class="form-control accordion-search search-input"
                        id="inputValidation"
                        (input)="role.filter($any($event.target).value)"
                        placeholder="Search..."
                      />
                      <span class="form-control-feedback">
                        <i class="fa fa-search icon"></i>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                  </ng-template>
                </ng-select>
                <div
                  *ngIf="
                    (manageUserForm.controls['accessRole']?.touched || submitted) &&
                    manageUserForm.controls['accessRole']?.invalid
                  "
                  class="input-error"
                >
                  Role is required
                </div>
              </div>
            </div>
            <div class="col-sm-6 d-flex" *ngIf="!isStandaloneMode">
              <div
                class="checkbox-text checkBoxAlienMent"
                [ngClass]="shouldShowRoleField() ? 'col-sm-6 mb-1' : 'col-sm-12  mb-4'"
              >
                <input
                  class="chkOverview"
                  type="checkbox"
                  formControlName="isActive"
                  [(ngModel)]="activeCheckbox"
                />
                <span> Active</span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6">
              <div class="form-group required">
                <label *ngIf="manageUserForm.get('country')?.value" class="sub-header-drpdown pb-2"
                  >Country</label
                >
                <ng-select
                  [clearable]="true"
                  [clearOnBackspace]="false"
                  #country
                  class="personalInputFiled addScroll"
                  #select
                  [items]="countries"
                  [searchable]="false"
                  formControlName="country"
                  bindLabel="name"
                  [searchFn]="commonInputSearch"
                  (change)="onChange($event?.id)"
                  placeholder="Country *"
                >
                  <ng-template ng-header-tmp>
                    <div class="has-feedback">
                      <input
                        type="text"
                        class="form-control accordion-search search-input"
                        id="inputValidation"
                        placeholder="Search..."
                        (input)="country.filter($any($event.target).value)"
                      />
                      <span class="form-control-feedback">
                        <i class="fa fa-search icon"></i>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                      {{ item.name }}
                    </div>
                  </ng-template>
                </ng-select>
                <div
                  *ngIf="
                    (manageUserForm.controls['country']?.touched || submitted) &&
                    manageUserForm.controls['country']?.invalid
                  "
                  class="input-error"
                >
                  Country is required.
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label
                  *ngIf="manageUserForm.get('state')?.value || manageUserForm.get('country')?.value"
                  class="sub-header-drpdown pb-2"
                  >State</label
                >
                <ng-container>
                  <ng-select
                    [clearable]="true"
                    [clearOnBackspace]="false"
                    #state
                    [items]="stateList"
                    [searchable]="false"
                    bindLabel="name"
                    [searchFn]="commonInputSearch"
                    formControlName="state"
                    placeholder="State"
                  >
                    <ng-template ng-header-tmp>
                      <div class="has-feedback">
                        <input
                          type="text"
                          class="form-control accordion-search search-input"
                          id="inputValidation"
                          placeholder="Search..."
                          (input)="state.filter($any($event.target).value)"
                        />
                        <span class="form-control-feedback">
                          <i class="fa fa-search icon"></i>
                        </span>
                      </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                      <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                        {{ item.name }}
                      </div>
                    </ng-template>
                  </ng-select>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group textarea">
                <div class="services-form address-box">
                  <textarea
                    cols="20"
                    maxlength="50"
                    rows="2"
                    spellcheck="false"
                    formControlName="address"
                    placeholder="Address"
                  ></textarea>
                  <label>Address</label>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <piqet-angular-common-input
                  formControlName="postCode"
                  [control]="manageUserForm.get('postCode')"
                  label="Postcode"
                  placeholder="Postcode"
                  [maxLength]="10"
                  [submitted]="submitted"
                  [inputType]="'text'"
                >
                </piqet-angular-common-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <piqet-angular-common-input
                  formControlName="phone"
                  [control]="manageUserForm.get('phone')"
                  label="Phone"
                  placeholder="Phone"
                  [maxLength]="13"
                  [submitted]="submitted"
                  [inputType]="'tel'"
                >
                </piqet-angular-common-input>
              </div>
            </div>
          </div>
          <div
            class="row"
            *ngIf="
              !isShowInput ||
              (customData?.isSAdmin && isShowInput) ||
              (customData?.isAdmin && isShowInput) ||
              isStandaloneMode
            "
          >
            <div class="col-sm-6">
              <div class="required">
                <piqet-angular-common-input
                  formControlName="Password"
                  [control]="manageUserForm.get('Password')"
                  label="Password"
                  placeholder="Password"
                  [maxLength]="50"
                  [submitted]="submitted"
                  [inputType]="'password'"
                  [showPasswordToggle]="true"
                  (keyupEvent)="validationsPassword()"
                  [errorMessages]="{
                    required: 'The password field is required.'
                  }"
                >
                </piqet-angular-common-input>

                <div class="security-tabs">
                  <p [ngClass]="upperCaseCharactersflag ? 'hightlightText' : 'NonhightlightText'">
                    One uppercase character
                  </p>
                  <p [ngClass]="lowerCaseCharactersflag ? 'hightlightText' : 'NonhightlightText'">
                    One lowercase character
                  </p>
                  <p [ngClass]="numberCharactersflag ? 'hightlightText' : 'NonhightlightText'">
                    One number
                  </p>
                  <p [ngClass]="specialCharactersflag ? 'hightlightText' : 'NonhightlightText'">
                    One special character
                  </p>
                  <p [ngClass]="minLengthsflag ? 'hightlightText' : 'NonhightlightText'">
                    8 characters minimum
                  </p>
                </div>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group required">
                <piqet-angular-common-input
                  formControlName="ConfirmPassword"
                  [control]="manageUserForm.get('ConfirmPassword')"
                  label="Confirm password"
                  placeholder="Confirm Password"
                  [maxLength]="50"
                  [submitted]="submitted"
                  [inputType]="'password'"
                  [showPasswordToggle]="true"
                  [errorMessages]="{
                    required: 'The confirm password field is required.',
                    mustMatch: 'The password and confirm password fields do not match'
                  }"
                >
                </piqet-angular-common-input>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="shouldShowTriggerAutomation()">
            <div class="col-12">
              <div
                *ngIf="hasAutomationInProgress"
                class="alert alert-warning mt-3 alert-radius"
                role="alert"
              >
                The user currently has the following automation(s) active:
                {{ automationInProgressNames }}.
              </div>
            </div>
          </div>
          <div class="row" *ngIf="shouldShowTriggerAutomation()">
            <div class="col-sm-12 d-flex mt-3">
              <div class="checkbox-text form-group checkBoxAlienMent">
                <input class="chkOverview" type="checkbox" formControlName="triggerAutomation" />
                <span>Trigger automation</span>
              </div>
            </div>
            <div class="col-sm-6" *ngIf="manageUserForm.get('triggerAutomation')?.value">
              <div class="form-group">
                <label
                  *ngIf="manageUserForm.get('automationName')?.value"
                  class="sub-header-drpdown pb-2"
                  >Automation</label
                >
                <ng-container *ngIf="!isFromAdminOrg">
                  <ng-select
                    [clearable]="true"
                    [clearOnBackspace]="false"
                    #automationSelect
                    [items]="automationList || []"
                    formControlName="automationName"
                    [searchable]="false"
                    bindLabel="name"
                    bindValue="id"
                    [searchFn]="commonInputSearch"
                    placeholder="Automation name"
                  >
                    <ng-template ng-header-tmp>
                      <div class="has-feedback">
                        <input
                          type="text"
                          class="form-control accordion-search search-input"
                          id="inputValidation"
                          placeholder="Search..."
                          (input)="automationSelect.filter($any($event.target).value)"
                        />
                        <span class="form-control-feedback">
                          <i class="fa fa-search icon"></i>
                        </span>
                      </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                      <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                        {{ item.name }}
                        <span *ngIf="item.flag" class="badge text-bg-success">Active</span>
                      </div>
                    </ng-template>
                  </ng-select>
                </ng-container>
              </div>
            </div>
          </div>
        </form>
        <div class="setButtonAndError box-footer">
          <div class="modal-footer">
            <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
            <button
              type="button"
              class="modelBtn purpleBtnHoverEffect"
              (click)="onSave()"
              *ngIf="checkEntireAccess"
            >
              {{ isStandaloneMode ? 'Create account' : 'Save' }}
            </button>
          </div>

          <div
            class="redErrorTag"
            *ngIf="
              submitted &&
              (this.manageUserForm.invalid ||
                this.manageUserForm.controls['accessRole'].value?.name == 'Role')
            "
          >
            <div class="bigScreenErrContain">
              <div>
                <span> <img src="./assets/icons/swalDeletion.svg" width="53" height="48" /></span>
              </div>
              <div>
                <div class="mb-3">
                  <span>To proceed please complete the following fields : </span>
                </div>
                <div
                  class="topBottomCss"
                  *ngIf="
                    submitted ||
                    (manageUserForm.controls['firstName'].errors &&
                      manageUserForm.controls['firstName'].touched)
                  "
                >
                  <div *ngIf="manageUserForm.controls['firstName'].errors?.['required']">
                    First name
                  </div>
                </div>
                <div class="topBottomCss" *ngIf="manageUserForm.controls['firstName'].touched">
                  <div
                    *ngIf="manageUserForm.controls['firstName'].value?.length < 2 && !this.manageUserForm.controls['firstName'].errors?.['required']"
                  >
                    The firstname must be at least 2 characters long.
                  </div>
                </div>
                <div
                  class="topBottomCss"
                  *ngIf="
                    submitted ||
                    (manageUserForm.controls['lastName'].errors &&
                      manageUserForm.controls['lastName'].touched)
                  "
                >
                  <div *ngIf="manageUserForm.controls['lastName'].errors?.['required']">
                    Last name
                  </div>
                </div>
                <div class="topBottomCss" *ngIf="manageUserForm.controls['lastName'].touched">
                  <div
                    *ngIf="manageUserForm.controls['lastName'].value?.length < 2 && !this.manageUserForm.controls['lastName'].errors?.['required']"
                  >
                    The lastname must be at least 2 characters long.
                  </div>
                </div>
                <div class="topBottomCss">
                  <div
                    *ngIf="
                      (manageUserForm.get('email')?.touched || submitted) &&
                      manageUserForm.get('email')?.invalid
                    "
                  >
                    {{ !manageUserForm.get('email')?.value ? ' Email ' : 'Invalid email address' }}
                  </div>
                </div>

                <div class="topBottomCss">
                  <div
                    *ngIf="
                      (manageUserForm.controls['accessRole']?.touched || submitted) &&
                      manageUserForm.controls['accessRole']?.invalid
                    "
                  >
                    Role
                  </div>
                </div>
                <div class="topBottomCss">
                  <div
                    *ngIf="
                      (manageUserForm.controls['country']?.touched || submitted) &&
                      manageUserForm.controls['country']?.invalid
                    "
                  >
                    Country
                  </div>
                </div>
                <div class="topBottoCss">
                  <div *ngIf="submitted && manageUserForm.controls['phone'].errors">
                    <div *ngIf="manageUserForm.controls['phone'].errors?.['required']">Phone</div>
                    <div *ngIf="manageUserForm.controls['phone'].errors?.['maxlength']">
                      Please enter valid phone number.
                    </div>
                  </div>
                </div>
                <div class="topBottomCss">
                  <div
                    *ngIf="(manageUserForm.get('Password')?.touched || submitted) && manageUserForm.controls['Password'].errors?.['required']"
                  >
                    Password
                  </div>
                </div>
                <div class="topBottomCss" *ngIf="!isFromAdminOrg">
                  <div *ngIf="submitted && manageUserForm.controls['organizationName']?.invalid">
                    Organization name is required
                  </div>
                </div>
                <div class="topBottomCss">
                  <div
                    *ngIf="
                      (manageUserForm.get('ConfirmPassword')?.touched || submitted) &&
                      manageUserForm.get('ConfirmPassword')?.invalid
                    "
                  >
                    {{
                      !manageUserForm.get('ConfirmPassword')?.value
                        ? 'Confirm password'
                        : 'The
                                        password and confirm password fields do not match'
                    }}
                  </div>
                </div>
                <div class="topBottomCss">
                  <div
                    *ngIf="
                      (manageUserForm.get('ConfirmPassword')?.touched || submitted) &&
                      manageUserForm.get('ConfirmPassword')?.invalid &&
                      (upperCaseCharactersflag ||
                        lowerCaseCharactersflag ||
                        numberCharactersflag ||
                        specialCharactersflag ||
                        minLengthsflag)
                    "
                  >
                    Please match password pattern
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
